var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTaskList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    fillRule: "evenodd",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.9,453H22.1a2.109,2.109,0,0,0-2.1,2.109v13.782A2.109,2.109,0,0,0,22.1,471H35.9a2.109,2.109,0,0,0,2.1-2.109V455.109A2.109,2.109,0,0,0,35.9,453Zm-10.005,1.406h6.218v1.36H25.891v-1.36ZM36.6,468.891a0.7,0.7,0,0,1-.7.7H22.1a0.7,0.7,0,0,1-.7-0.7V455.109a0.7,0.7,0,0,1,.7-0.7h2.384v2.063a0.7,0.7,0,0,0,.7.7H32.81a0.7,0.7,0,0,0,.7-0.7v-2.063H35.9a0.7,0.7,0,0,1,.7.7v13.782Zm-10.707-8.274a0.7,0.7,0,0,1-.7.7H24.5a0.7,0.7,0,0,1,0-1.406h0.69A0.7,0.7,0,0,1,25.891,460.617Zm8.31,0a0.7,0.7,0,0,1-.7.7H27.948a0.7,0.7,0,0,1,0-1.406H33.5A0.7,0.7,0,0,1,34.2,460.617Zm-8.31,2.766a0.7,0.7,0,0,1-.7.7H24.5a0.7,0.7,0,0,1,0-1.406h0.69A0.7,0.7,0,0,1,25.891,463.383Zm8.31,0a0.7,0.7,0,0,1-.7.7H27.948a0.7,0.7,0,0,1,0-1.406H33.5A0.7,0.7,0,0,1,34.2,463.383Zm-8.31,2.765a0.7,0.7,0,0,1-.7.7H24.5a0.7,0.7,0,0,1,0-1.407h0.69A0.7,0.7,0,0,1,25.891,466.148Zm8.31,0a0.7,0.7,0,0,1-.7.7H27.948a0.7,0.7,0,0,1,0-1.407H33.5A0.7,0.7,0,0,1,34.2,466.148Z",
    transform: "translate(-20 -453)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskList);
export default __webpack_public_path__ + "static/media/task-list.a5a85422.svg";
export { ForwardRef as ReactComponent };